import Client from './client';

export default class Backfills extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  putCumulativeAndDaily(options = {}) {
    return this.makeRequest(`${this.host}/experiment-engine/backfill/cumulative/daily`, {
      ...options,
       method: 'PUT',
    });
  }

  putDaily(options = {}) {
    return this.makeRequest(`${this.host}/experiment-engine/backfill/daily`, {
      ...options,
       method: 'PUT',
    });
  }

  putTotalsAndDaily(options = {}) {
    return this.makeRequest(`${this.host}/experiment-engine/backfill/totals/daily`, {
      ...options,
       method: 'PUT',
    });
  }

}
